import { render } from "./DesktopFooter.vue?vue&type=template&id=12d6e17c&scoped=true&ts=true"
import script from "./DesktopFooter.vue?vue&type=script&lang=ts"
export * from "./DesktopFooter.vue?vue&type=script&lang=ts"

import "./DesktopFooter.vue?vue&type=style&index=0&id=12d6e17c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d6e17c"]])

export default __exports__